import React, { useEffect, useReducer, useState, forwardRef } from "react";
import { Spinner } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import ReusableDropdown from "../../../../Component/BasicComponents/Dropdowns/Dropdown";
import CustomInput from "../../../../Component/BasicComponents/CustomInput";
import "react-datepicker/dist/react-datepicker.css";
import {
  useAddOutlet,
  useAllTowns,
  useOutletById,
  useOutletMaritalStatus,
  useOutletQulificationList,
  useOutletSalutation,
  useOutletStatus,
  useOutletType,
  useUpdateOutlet,
} from "../hooks/useCustomer";
import { useClassificationListData } from "../../Classification/hooks/useClassification";
import { FormReducer, FORM_ACTIONS, INITIALSTATES } from "./FetchReducer";
import RouteDropdown from "../../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import PaginatedRouteDropdown from "../../../../Component/BasicComponents/Dropdowns/PaginatedDropdownWrapper";
import { getOutletQualificationList, getTownFilter } from "../hooks/CustomerRepository";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import { handleMedia } from "../../../edetailing/repository/EdetailingRepository";
import AddressModal from "./AddressModal";
import RouteModal from "../../../../Component/BasicComponents/Modal/RouteModal";
import { showToast } from "../../../../utils/toastUtils";


interface prop {
  modalClose: () => void;
  customerID?: number;
  mode: "add" | "edit";
  onSuccess?: (outletId: number) => void; // 
}

interface CustomDateInputProps {
  value?: string;
  onClick?: () => void;
  placeholder?: string;
  label?: string;
}

const CustomDateInput = forwardRef<HTMLInputElement, CustomDateInputProps>(
  ({ value, onClick, placeholder, label }, ref) => (
    <CustomInput
      label={label}
      placeholder={placeholder}
      value={value}
      readOnly
      onClick={onClick} // 🟢 IMPORTANT: this triggers the date picker
      ref={ref as any} // 🟢 IMPORTANT: required by react-datepicker
      required
      style={{
        height: "42px",
        border: "1px solid #EDEDED",
        borderRadius: "4px",
        // padding: "10px",
        fontSize: "14px",
        cursor: "pointer",
        width: "100%",
        // flex:1
      }}
    />
  )
);

const CustomerModal: React.FC<prop> = ({ modalClose, mode, customerID, onSuccess }) => {
  console.log("customerID", customerID);
  const [state, dispatch] = useReducer(FormReducer, INITIALSTATES);
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isEdit = !!customerID;
  const Navigate = useNavigate();
  const [outlet,setOutlet]=useState("")
  
  const BASE_URL = "https://tspc-development.truesales.in/media?id=";

  const { data: getOutlet,isLoading:isLoadingOutlet } = useOutletById({
    enabled: !!customerID,
    outletId: customerID,
  });

  const { data: customerOutletType,isLoading:isLoadingOutletType  } = useOutletType({ enabled: true });
  const { data: outletSalutation ,isLoading:isLoadingSalutation } = useOutletSalutation({ enabled: true });
  const { data: outletMaritalStatus,isLoading:isLoadingMaritalStatus  } = useOutletMaritalStatus({
    enabled: true,
  });
  const { data: classificationList,isLoading:isLoadingClassification  } = useClassificationListData({
    enable: true,
    params: { fetch: "all" },
  });
  const { data: outletStatus,isLoading:isLoadingOutletStatus  } = useOutletStatus({ enabled: true });

  // const { data: allTowns } = useAllTowns({
  //   enabled: true,
  //   params: {
  //     page: 1,
  //     limit: 10,
  //     search: townSearch,
  //   },
  // });

  const { data: getQualification, isLoading:isLoadingQualification  } = useOutletQulificationList({
    enabled: true,
  });

  const formatOptions = (dataObj: Record<string, string> = {}) =>
    Object.keys(dataObj||{}).map((key) => ({ id: key, label: dataObj[key] }));

  const formattedSalutation = formatOptions(outletSalutation?.data);
  const formattedMaritalStatus = formatOptions(outletMaritalStatus?.data);
  console.log(formattedMaritalStatus,'sfdssdfsdfsd')
  const formattedClassification = formatOptions(
    classificationList?.data?.data?.Classifications??{}
  );
  const formattedOutletStatus = formatOptions(outletStatus?.data);
  // const formattedTowns = formatOptions(allTowns?.data?.TownsData);

  const formattedQualification = (
    getQualification?.data?.OutletQualifications || []
  ).map((item: any) => ({
    id: item.QualificationName,
    label: item.QualificationName,
  }))??[];

const handleChnageInput = (field: string, eventOrValue: any) => {
  let value;

  if (Array.isArray(eventOrValue)) {
    // Multi-select case
    value = eventOrValue;
  } else if (typeof eventOrValue === "string" || typeof eventOrValue === "number") {
    value = eventOrValue;
  } else if (
    typeof eventOrValue === "object" &&
    "id" in eventOrValue &&
    "label" in eventOrValue
  ) {
    value = { id: eventOrValue.id, label: eventOrValue.label };
  } else {
    value = (eventOrValue as React.ChangeEvent<HTMLInputElement>).target.value;
  }

  dispatch({ type: FORM_ACTIONS.SET_FIELD, field, value });
};



  const getLabelFromId = (
    list: { id: string | number; label: string }[],
    id: string | number
  ) => {
    return list?.find((item) => item.id == id)?.label || "";
  };




  const { mutate: updateOutlet,isPending:isPending } = useUpdateOutlet();

  useEffect(() => {
    if (isEdit && getOutlet?.data?.OutletsData) {
      const outlet = getOutlet?.data?.OutletsData;

      const maritalOption = formattedMaritalStatus.find(
  (opt) => opt.id == outlet.OutletMaritalStatus
);

console.log('marital',maritalOption)
      console.log('outlet',outlet)

      console.log('useselector',state)

      dispatch({
        type: FORM_ACTIONS.SET_FIELD,
        field: "OutletName",
        value: outlet.OutletName || "",
      });
      dispatch({
        type: FORM_ACTIONS.SET_FIELD,
        field: "Cust_Code",
        value: outlet.OutletCode || "",
      });
      dispatch({
        type: FORM_ACTIONS.SET_FIELD,
        field: "Contact_No",
        value: outlet.OutletContactNo,
      });  
       dispatch({
        type: FORM_ACTIONS.SET_FIELD,
        field: "Contact_Outlet_Name",
        value: outlet.OutletContactName,
      });
      dispatch({
        type: FORM_ACTIONS.SET_FIELD,
        field: "Landline_No",
        value: outlet.OutletLandlineno || "",
      });
      dispatch({
        type: FORM_ACTIONS.SET_FIELD,
        field: "Email",
        value: outlet.OutletEmail || "",
      });
      dispatch({
        type: FORM_ACTIONS.SET_FIELD,
        field: "Opening_date",
        value: outlet.OutletOpeningDate,
      });
      dispatch({
        type: FORM_ACTIONS.SET_FIELD,
        field: "Birthdate",
        value: outlet.OutletContactBday || "",
      });
      dispatch({
        type: FORM_ACTIONS.SET_FIELD,
        field: "Anniversary",
        value: outlet.OutletContactAnniversary || "",
      });
      dispatch({
        type: FORM_ACTIONS.SET_FIELD,
        field: "Rengo",
        value: outlet.OutletRegno || "",
      });

      // Dropdowns (as { id, label })
      dispatch({
        type: FORM_ACTIONS.SET_FIELD,
        field: "Type",
        value: { id: outlet.OutlettypeId, label: outlet.OutletTypeName },
      });
      dispatch({
        type: FORM_ACTIONS.SET_FIELD,
        field: "Salutation",
        value: { id: outlet.OutletSalutation, label: outlet.OutletSalutation },
      });
      dispatch({
        type: FORM_ACTIONS.SET_FIELD,
        field: "Classification",
        value: {
          id: outlet.OutletClassification,
          label: getLabelFromId(
            formattedClassification,
            outlet.OutletClassification
          ),
        },
      });
      dispatch({
        type: FORM_ACTIONS.SET_FIELD,
        field: "Status",
        value: { id: outlet.OutletStatus, label: outlet.OutletStatus },
      });
      dispatch({
  type: FORM_ACTIONS.SET_FIELD,
  field: "Marital_Status",
  value: maritalOption || { id: outlet.OutletMaritalStatus, label: outlet.OutletMaritalStatus },
});

       dispatch({
        type: FORM_ACTIONS.SET_FIELD,
        field: "Qualification",
       value: outlet?.OutletQualification
    ? outlet.OutletQualification.split(",").map((item: string) => ({
        label: item.trim(),
        id: item.trim(),
      }))
    : [],     
      });
      // If Potential_Month_Sales is numeric or string
      dispatch({
        type: FORM_ACTIONS.SET_FIELD,
        field: "Potential_Month_Sales",
        value: outlet.OutletPotential || "",
      });

      // If Town/TownCode needed later
      dispatch({
        type: FORM_ACTIONS.SET_FIELD,
        field: "town",
        value: { id: outlet.Itownid, label: outlet.TownName },
      });   
      dispatch({
        type: FORM_ACTIONS.SET_FIELD,
        field: "media",
        value: outlet.OutletMediaId,
      });
    }
    setLoading(false)
  }, [getOutlet?.data?.OutletsData, isEdit]);

  const { mutate: addOutlet,isPending:isSubmit} = useAddOutlet();

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (file) {
        try {
          const mediaId = await handleMedia(file);
          console.log("mediaiii", mediaId);
  
          handleChnageInput("media",mediaId);
          console.log("Uploaded Media ID:", mediaId);
        } catch (error) {
          console.error("Media upload failed:", error);
        }
      }
    };

const validateForm = (payload: any, mode: "add" | "edit") => {
  const errors: string[] = [];

  // outletId
  if (mode === "edit" && (!payload.outletId || payload.outletId <= 0)) {
    errors.push("Invalid outletId.");
  }

  // outletType
  if (!payload.outletType || isNaN(payload.outletType) || payload.outletType <= 0) {
    errors.push("Outlet Type is required.");
  }

  // classification
  if (!payload.classification || isNaN(payload.classification) || payload.classification <= 0) {
    errors.push("Classification is required.");
  }

  // townId
  if (!payload.townId || isNaN(payload.townId) || payload.townId <= 0) {
    errors.push("Town is required.");
  }

  // outletName
  if (!payload.outletName || payload.outletName.length < 3 || payload.outletName.length > 100) {
    errors.push("Outlet Name must be 3–100 characters.");
  }

  // outletCode (only edit)
  if (mode === "edit" && (!payload.outletCode || payload.outletCode.length < 3 || payload.outletCode.length > 50)) {
    errors.push("Outlet Code must be 3–50 characters.");
  }

  // salutation
  if (!payload.salutation) {
    errors.push("Salutation is required.");
  }

  // outletContactName
  if (!payload.outletContactName || payload.outletContactName.length < 3 || payload.outletContactName.length > 100) {
    errors.push("Contact Name must be 3–100 characters.");
  }

  // openingDate
  if (!payload.openingDate) {
    errors.push("Opening Date is required.");
  }

  // outletContactNo
  if (!/^[6-9]\d{9}$/.test(payload.outletContactNo || "")) {
    errors.push("Contact No must be 10 digits starting with 6–9.");
  }

  // maritalStatus
  if (!payload.maritalStatus) {
    errors.push("Marital Status is required.");
  }

  // outletLandlineNo (optional, validate if provided)
  if (payload.outletLandlineNo && !/^\d{10,15}$/.test(payload.outletLandlineNo)) {
    errors.push("Landline No must be 10–15 digits.");
  }

  // outletEmail (optional, validate if provided)
  if (payload.outletEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.outletEmail)) {
    errors.push("Invalid email format.");
  }

  // birthDate (optional, validate if provided)
  if (payload.birthDate && !/^\d{4}-\d{2}-\d{2}$/.test(payload.birthDate)) {
    errors.push("Birth Date must be in YYYY-MM-DD format.");
  }

  // anniversaryDate (optional, validate if provided)
  if (payload.anniversaryDate && !/^\d{4}-\d{2}-\d{2}$/.test(payload.anniversaryDate)) {
    errors.push("Anniversary Date must be in YYYY-MM-DD format.");
  }

  // status (only edit)
  if (mode === "edit" && !payload.status) {
    errors.push("Status is required for edit.");
  }

  // potentialMonthlySales (optional)
  if (payload.potentialMonthlySales && !/^\d{1,20}$/.test(payload.potentialMonthlySales)) {
    errors.push("Potential Monthly Sales must be numeric (1–20 digits).");
  }

  // regNo (optional)
  if (payload.regNo && payload.regNo.length < 1) {
    errors.push("Invalid RegNo.");
  }

  // outletMediaId (optional, integer check)
  if (payload.outletMediaId && isNaN(Number(payload.outletMediaId))) {
    errors.push("Invalid Media ID.");
  }

  return errors;
};



  const handlesubmit = async(e: React.FormEvent) => {
    e.preventDefault();

    if (isSubmitting) return;
    setIsSubmitting(true);

    console.log('state.qualification',state.Qualification)

    try{

    const payload: any = {
      outletType: state.Type?.id || "",
      classification: state.Classification?.id || "",
      townId: state.town?.id || "", // assuming Town is also an object
      outletName: state.OutletName || "",
      outletCode: state.Cust_Code || "",
      salutation: state.Salutation?.id || "",
      outletContactName: state.Contact_Outlet_Name || "",
      openingDate: state.Opening_date,
      outletContactNo: state.Contact_No || "",
      outletLandlineNo: state.Landline_No || "",
      outletEmail: state.Email || "",
      birthDate: state.Birthdate,
      anniversaryDate: state.Anniversary,
      potentialMonthlySales: state.Potential_Month_Sales || "",
      qualification: Array.isArray(state.Qualification)
  ? state.Qualification.map((b: any) => b.label).join(", ")
  : "",
      regNo: state.Rengo || "",
      maritalStatus: state.Marital_Status?.id || "",
      outletMedia:"",
      outletMediaId:state?.media||""
    };

    if (isEdit) {
      payload.outletId = customerID;
      payload.status = state.Status?.id;
      console.log("Update Payload: ", payload);
      // mutate(payload)
      // updateOutlet(payload);
    } else {
      console.log("Create Payload: ", payload);
      // addOutlet(payload);
    }

    const errors = validateForm(payload, mode);
    if (errors.length > 0) {
      showToast.warning( errors.join("\n"));
      return;
    }

    const mutationFn = mode === "edit" ? updateOutlet : addOutlet;
    await mutationFn(payload, {
      onSuccess: (data) => {
        // alert("data: " + JSON.stringify(data));
        if (mode === "add" && data?.data?.OutletId) {
          onSuccess?.(data.data.OutletId); // chain to AddressModal
        }
        modalClose();   
      },
      onError: (err) => {
        console.error(err);
        setIsSubmitting(false);
      },
    });
  }finally{
    setIsSubmitting(false)
  }
  };


  

  // Utility function to convert "dd-mm-yyyy" → "yyyy-mm-dd"
  // const formatDate = (dateStr: string) => {
  //   if (!dateStr) return "";
  //   const [dd, mm, yyyy] = dateStr.split("-");
  //   return `${yyyy}-${mm}-${dd}`;
  // };

 const isDataLoading =
  isLoadingClassification ||
  isLoadingOutletType ||
  isLoadingSalutation ||
  isLoadingMaritalStatus ||
  isLoadingOutletStatus ||
  isLoadingQualification ||
  (isEdit && isLoadingOutlet);

  if (isDataLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "60vh" }}
      >
        <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
      </div>
    );
  }

  return (
    <form>
      <div className="row mb-0 col-sm-12">
        <div className="col-sm-3">
          <ReusableDropdown
            DropdownHeading="Outlet Type*"
            label={state.Type == "" ? "Select Outlet Type" : state?.Type?.label}
            height="42px"
            onSelect={(value) => handleChnageInput("Type", value)}
            options={customerOutletType?.data ? customerOutletType?.data : []}
          />
        </div>

        <div className="col-sm-3">
          <ReusableDropdown
            DropdownHeading="Classification*"
            label={
              state.Classification == ""
                ? "Select Classification"
                : state?.Classification?.label
            }
            height="42px"
            border="0.5px solid #D1D1D1"
            onSelect={(value) => handleChnageInput("Classification", value)}
            options={
              formattedClassification || [
                { id: 1, label: "Org Unit A" },
                { id: 2, label: "org Unit B" },
              ]
            }
          />
        </div>

        <div className="col-sm-3">
          <CustomInput
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChnageInput("OutletName", e)
            }
            label="Outlet Name*"
            placeholder="Enter Outlet Name"
            value={state.OutletName}
            required
            style={{
              border: "1px solid #EDEDED",
              borderRadius: "4px",
              padding: "10px",
              fontSize: "14px",
            }}
          />
        </div>

        <div className="col-sm-3">
          <CustomInput
            label= {mode=="edit"? "Legacy Code*":"Legacy code"}
            value={state.Cust_Code}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChnageInput("Cust_Code", e)
            }
            required
            style={{
              border: "1px solid #EDEDED",
              borderRadius: "4px",
              padding: "10px",
              fontSize: "14px",
            }}
          />
        </div>

        <div className="col-sm-3">
          <ReusableDropdown
            DropdownHeading="Salutation*"
            label={
              state.Salutation == ""
                ? "Select Salutation"
                : state?.Salutation?.label
            }
            onSelect={(value) => handleChnageInput("Salutation", value)}
            height="42px"
            border="0.5px solid #D1D1D1"
            options={formattedSalutation || []}
          />
        </div>

        <div className="col-sm-3">
          <CustomInput
            label="Contact Name*"
            placeholder="Enter Contact Name"
            value={state.Contact_Outlet_Name}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChnageInput("Contact_Outlet_Name", e)
            }
            required
            style={{
              border: "1px solid #EDEDED",
              borderRadius: "4px",
              padding: "10px",
              fontSize: "14px",
            }}
          />
        </div>

        <div className="col">
          <CustomInput
            label={"Opening Date*"}
            placeholder={"Enter Opening Date"}
            value={state.Opening_date}
            onChange={(e: any) => {
              handleChnageInput("Opening_date", e.target.value);
            }}
            max={new Date().toISOString().split("T")[0]}
            required
            type="date"
            style={{
              height: "42px",
              border: "1px solid #EDEDED",
              borderRadius: "4px",
              padding: "10px",
              fontSize: "14px",
              cursor: "pointer",
              width: "100%",
            }}
          />

         
        </div>

        <div className="col-sm-3">
          <CustomInput
            label="Contact No*"
            placeholder="Enter Contact No."
            value={state.Contact_No}
            maxLength={10}
            type="number"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const value = e.target.value;
              // Allow only digits and max 10 characters
              if (/^\d{0,10}$/.test(value)) {
                handleChnageInput("Contact_No", e);
              }
            }}
            required
            style={{
              border: "1px solid #EDEDED",
              borderRadius: "4px",
              padding: "10px",
              fontSize: "14px",
            }}
          />
        </div>

        <div className="col-sm-3">
          <CustomInput
            label="Landline No"
            placeholder="Enter Landline no."
            value={state.Landline_No}
            type="number"
            maxLength={10}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const value = e.target.value;
              // Allow only digits and max 10 characters
              if (/^\d{0,10}$/.test(value)) {
                handleChnageInput("Landline_No", e);
              }
            }}
            style={{
              border: "1px solid #EDEDED",
              borderRadius: "4px",
              padding: "10px",
              fontSize: "14px",
            }}
          />
        </div>

        <div className="col-sm-3">
          <CustomInput
            label="Email"
            placeholder="Enter Email"
            type="email"
            value={state.Email}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChnageInput("Email", e)
            }
            required
            style={{
              border: "1px solid #EDEDED",
              borderRadius: "4px",
              padding: "10px",
              fontSize: "14px",
            }}
          />
        </div>
        <div className="col-sm-3">
          <PaginatedRouteDropdown
            initialSelectedOptions={state.town}
            DropdownHeading="Town*"
            placeholder="Select Town"
            fetchOptions={async (page: any, search: any) => {
              const res = await getTownFilter({
                page,
                limit: 10,
                search: search || "",
              });
              return Object.keys(res?.data?.TownsData ?? {}).map((key) => ({
                id: key,
                label: res?.data?.TownsData[key],
              }));
            }}
            onChange={(val: any) => handleChnageInput("town", val)}
          />
        </div>
    
        <div className="col-sm-3">
          <CustomInput
            label={"Birth Date"}
            placeholder={"Enter Birth Date"}
            value={state.Birthdate}
            onChange={(e: any) => {
              handleChnageInput("Birthdate", e.target.value);
            }}
            max={new Date().toISOString().split("T")[0]}
            required
            type="date"
            style={{
              height: "42px",
              border: "1px solid #EDEDED",
              borderRadius: "4px",
              padding: "10px",
              fontSize: "14px",
              cursor: "pointer",
              width: "100%",
            }}
          />
        </div>
        <div className="col-sm-3">
          <ReusableDropdown
            DropdownHeading="Marital Status*"
            label={
              state.Marital_Status == ""
                ? "Select Marital Status"
                : state.Marital_Status?.label
            }
            height="42px"
            border="0.5px solid #D1D1D1"
            options={formattedMaritalStatus || []}
            onSelect={(e) => {
              handleChnageInput("Marital_Status", e);
            }}
            value={state.Marital_Status}
          />
        </div>

        <div className="col-sm-3">
          <CustomInput
            label={"Anniversary Date"}
            placeholder={"Enter Anniversary Date"}
            value={state.Anniversary}
            onChange={(e: any) => {
              handleChnageInput("Anniversary", e.target.value);
            }}
            max={new Date().toISOString().split("T")[0]}
            required
            type="date"
            style={{
              height: "42px",
              border: "1px solid #EDEDED",
              borderRadius: "4px",
              padding: "10px",
              fontSize: "14px",
              cursor: "pointer",
              width: "100%",
            }}
          />
        </div>
        {mode == "edit" && (
          <div className="col-sm-3">
            <ReusableDropdown
              DropdownHeading={mode=="edit"?"Status*":"Status"}
              label={
                state?.Status == "" ? "Select Status" : state?.Status?.label
              }
              height="42px"
              border="0.5px solid #D1D1D1"
              onSelect={(value) => handleChnageInput("Status", value)}
              options={
                formattedOutletStatus || [
                  { id: 1, label: "Org Unit A" },
                  { id: 2, label: "org Unit B" },
                ]
              }
            />
          </div>
        )}

        <div className="col-sm-3">
          <CustomInput
            label="Potential Monthly Sales "
            placeholder="Enter Potential Monthly Sales"
            value={state?.Potential_Month_Sales}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChnageInput("Potential_Month_Sales", e)
            }
            required
            style={{
              border: "1px solid #EDEDED",
              borderRadius: "4px",
              padding: "10px",
              fontSize: "14px",
            }}
          />
        </div>

        <div className="col-sm-3">
          {/* <ReusableDropdown
            DropdownHeading="Qualification"
            isMulti={true}
            label={
              state.Qualification == ""
                ? "Select Qualification"
                : state.Qualification?.label
            }
            height="42px"
            border="0.5px solid #D1D1D1"
            onSelect={(e) => handleChnageInput("Qualification", e)}
            options={
              formattedQualification || [
                { id: 1, label: "Org Unit A" },
                { id: 2, label: "org Unit B" },
              ]
            }
          /> */}
<PaginatedRouteDropdown
            DropdownHeading="Qualification"
            isMulti={true}
            fetchOptions={async (page: any, search: any) => {
              const res = await getOutletQualificationList();
              return Object.values(res?.data?.OutletQualifications || {}).map((key: any) => ({
                id: key.QualificationName,
                label: key.QualificationName,
              }));
            }}
            onChange={(val: any) =>{handleChnageInput("Qualification",val)}}
            initialSelectedOptions={state.Qualification||[]}
          />
        </div>

        <div className="col-sm-3">
          <CustomInput
            label="Regno"
            value={state.Rengo}
            placeholder="Enter Registration No."
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChnageInput("Rengo", e)
            }
            required
            style={{
              border: "1px solid #EDEDED",
              borderRadius: "4px",
              padding: "10px",
              fontSize: "14px",
            }}
          />
        </div>
        <div className="col-sm-3">
          <label style={{ fontWeight: "500" }}>Media</label>
          <input
            type="file"
            className="form-control"
            accept="image/*"
            onChange={handleFileChange}
            style={{
              border: "2px solid #EDEDED",
              borderRadius: "8px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>

         <div className="col-sm-3">
      {state.media && (
        <div className="row mb-3">
          <div className="col-md-6" style={{ marginBottom: "10px" }}>
            <label style={{ fontWeight: "500", display: "block" }}>
              Uploaded Media
            </label>

            <img
              src={`${BASE_URL}${state.media}`}
              alt="Uploaded Media"
              style={{
                width: "100px",
                height: "100px",
                borderRadius: "8px",
                marginTop: "8px",
              }}
            />
          </div>
        </div>
      )}

</div>
        {/* Buttons */}
        <div className="d-flex justify-content-start gap-2 mt-2">
          <Btn
  style={{ backgroundColor: "#43B9B2", color: "white" }}
  type="submit"
  disabled={isSubmitting || isPending} // disable if either flag is true
  onClick={handlesubmit}
>
  {isSubmitting || isPending
    ? mode === "add"
      ? "Submitting..."
      : "Updating..."
    : mode === "add"
    ? "Submit"
    : "Update"}
</Btn>

          <Btn
            type="button"
            onClick={modalClose}
            style={{ backgroundColor: "#F9FAFC", color: "#000" }}
          >
            Cancel
          </Btn>
        </div>
        
      </div>
    
    </form>
  );
};

export default CustomerModal;


